import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const Title = styled.h1`
  margin: 0;
  color: #333f48;
  font-size: 40px;
  font-weight: 400;
  line-height: 46px;
  text-align: center;
  @media (${mediaQuery.tablet}) {
    line-height: 38px;
    font-size: 32px;
  }
  ${media.xs`
    line-height: 38px;
    font-size: 32px;
  `}
`;

export const Subtitle = styled.p`
  margin: 16px 0 0;
  color: #333f48;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  text-align: center;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  padding: 32px 24px 24px;
  ${media.xs`
    padding: 32px 16px 24px;
  `}
`;
